/** @jsx jsx */
import { Box, Label, Text } from '@bottlebooks/gatsby-design-system';
import { Link } from '@bottlebooks/gatsby-theme-base';
import { Trans } from '@lingui/macro';
import { jsx } from 'theme-ui';
import backToTop from '../../assets/back-to-top.svg';

export default function Footer({ children, homePath, className }) {
  function handleScrollToTop(e) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    e.preventDefault();
  }
  return (
    <Box
      as="footer"
      sx={{
        variant: 'styles.Footer',
        paddingY: [2, 4],
        paddingX: [2, 5],
        backgroundColor: 'background',
      }}
      className={className}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          paddingBottom: [2, 4],
          borderBottom: '1px solid',
          borderColor: 'border',
        }}
      >
        {children}
        <Link
          href="#"
          onClick={handleScrollToTop}
          sx={{ marginLeft: 'auto', color: 'black' }}
        >
          <Label>
            <Trans>Back to the top</Trans>{' '}
            <img src={backToTop} alt="" sx={{ verticalAlign: 'middle' }} />
          </Label>
        </Link>
      </Box>
      <Box sx={{ display: 'flex', paddingTop: [2, 4] }}>
        <Text variant="smallest" sx={{ color: 'lighterText' }}>
          <Trans>
            Powered by{' '}
            <Link
              href="https://www.bottlebooks.me"
              sx={{ textTransform: 'uppercase' }}
            >
              Bottlebooks
            </Link>
            ®
          </Trans>
        </Text>
        <Text
          variant="smallest"
          sx={{ marginLeft: 'auto', color: 'lighterText' }}
        >
          2020
        </Text>
      </Box>
    </Box>
  );
}
